module.exports = __webpack_public_path__ + "img/login-logo.64b86bb9.png";